import { ParkingLot, ParkingLotSectionDriveIn, ParkingLotSectionWithReservation } from './parking-lot';

export interface ParkingPrice {
  dayPrice: number;
  days: number;
  lot: [ParkingLot];
  price: number;
  spots: number;
  spots_req: number;
  status: number;
}

export interface ParkingLotSectionSeasonsPrices {
  low: number;
  high: number;
}

// === PARKING LOT SECTION WITH RESERVATION =================================================================

const PARKING_LOT_SECTION_WITH_RESERVATION_SEASONS_PRICES: Record<
  ParkingLotSectionWithReservation,
  ParkingLotSectionSeasonsPrices
> = {
  [ParkingLotSectionWithReservation.Closest]: { low: 39, high: 43 },
  [ParkingLotSectionWithReservation.CoveredPremium]: { low: 30, high: 35 },
  [ParkingLotSectionWithReservation.Premium]: { low: 27, high: 33 },
  [ParkingLotSectionWithReservation.Economy]: { low: 17, high: 20 },
};

export const getSeasonsPricesByParkingLotSectionWithReservation = (section: ParkingLotSectionWithReservation) =>
  PARKING_LOT_SECTION_WITH_RESERVATION_SEASONS_PRICES[section];

// === PARKING LOT SECTION DRIVE-IN ==========================================================================

const PARKING_LOT_SECTION_DRIVE_IN_SEASONS_PRICES: Record<ParkingLotSectionDriveIn, ParkingLotSectionSeasonsPrices> = {
  [ParkingLotSectionDriveIn.Closest]: { low: 41, high: 45 },
  [ParkingLotSectionDriveIn.CoveredPremium]: { low: 32, high: 37 },
  [ParkingLotSectionDriveIn.Premium]: { low: 28, high: 34 },
  [ParkingLotSectionDriveIn.Standard]: { low: 20, high: 23 },
  [ParkingLotSectionDriveIn.Street]: { low: 14.95, high: 14.95 },
};

export const getSeasonsPricesByParkingLotSectionDriveIn = (section: ParkingLotSectionDriveIn) =>
  PARKING_LOT_SECTION_DRIVE_IN_SEASONS_PRICES[section];
